<template>

    <b-container>
    <b-row>
        <b-col>

    <h1 v-if="!watched" class="font-weight-light text-center text-lg-left mt-4z mb-0">{{ $store.state.globalTheme.GALLERY_ALIAS }}</h1>
    <h1 v-if="watched" class="font-weight-light text-center text-lg-left mt-4z mb-0">My Courses</h1>
      <h2 v-if="watched" class="font-weight-light text-center text-lg-left mt-4z mb-0">Total - {{ time_watched }}</h2>

  <hr class="mt-2 mb-2">
<b-form>
     <b-form-group
             id="filter-1"
             label="Search"
             label-for="filter"
             class="text-sm-left"
     >
         <b-form-input v-focus v-on:submit.prevent v-model="search" id="filter" type="text"></b-form-input>
       <div>
  <b-row>
    <b-col class="mt-1">
  <label class="typo__label">Filter By {{ $store.state.globalTheme.AREA_ALIAS }}</label>
  <multiselect style=".multiselect__tag" v-model="value" :options="areas" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick some" label="name" track-by="name">
  </multiselect>
    </b-col>

    <b-col v-if="types.length > 0" class="mt-4 ml-2" cols="4">
      <b-form-group class="mt-2">
      <b-form-checkbox-group
        align="left"
        v-model="selectedtypes"
        :options="types"
        value-field="id"
        text-field="name"
        switches
        stacked
      ></b-form-checkbox-group>
    </b-form-group>
    </b-col>
  </b-row>


</div>

    </b-form-group>
</b-form>
    </b-col>
      </b-row>
        <div v-if="runningSearch" class="text-center my-3">
          <div class="spinner-border" role="status" :style="{width: '3rem',height: '3rem', color: $store.state.globalTheme.DEFAULT_COLOR}">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <Item :items="items" :authenticated="authenticated"/>
        <b-card v-if="count == 0 && loaded && !runningSearch">
          <b-card-title>No Results Found</b-card-title>
        </b-card>
      <b-button block v-if="!allLoaded && !runningSearch" v-on:click="loadNext" :style="{borderColor: $store.state.globalTheme.DEFAULT_COLOR, backgroundColor: $store.state.globalTheme.DEFAULT_COLOR}" class="mb-4">Load More</b-button>
      </b-container>
</template>

<script>

    import Item from './Item.vue'
    import { getAPI } from '../store/axios-base'
    import Multiselect from 'vue-multiselect'

    export default {

        data:() => {
            return {
                items:[],
                search:'',
                authenticated: false,
                page:1,
                awaitingSearch : false,
                areas:[],
                value: [],
                loaded: false,
                watched: false,
                count:0,
                runningSearch: false,
                types:[
                ],
                selectedtypes:[]
            }
        },
        computed:{
          cleanValue: function(){
              var cleaned = []
              this.value.forEach(function (item,index) {
                cleaned.push(item.id)
                  }
              )
              return cleaned
          },
          loggedIn: function () {
            return this.$store.getters.loggedIn
        },
          allLoaded:function () {
              return this.items.length == this.count
          }
        },
        watch: {
        loggedIn (newvar, oldvar) {
          this.FetchData(1,'','','');
          },
        search: function(val) {
        this.runningSearch = true;
        if (!this.awaitingSearch) {
          setTimeout(() => {
            this.page = 1
            this.items = []
            this.FetchData(this.page,this.search,this.cleanValue,this.selectedtypes);
            this.awaitingSearch = false;
            console.log('fetching based on search timer')
          }, 1500); // 1 sec delay
        }
        this.awaitingSearch = true;
      },

      value: function(val) {
        this.runningSearch = true;
        if (!this.awaitingSearch) {
          setTimeout(() => {
            this.page = 1
            this.items = []
            this.FetchData(this.page,this.search,this.cleanValue,this.selectedtypes);
            this.awaitingSearch = false;
            console.log('fetching based on search timer')
          }, 1500); // 1 sec delay
        }
        this.awaitingSearch = true;
      },

        selectedtypes: function(val) {
        this.runningSearch = true;
        if (!this.awaitingSearch) {
          setTimeout(() => {
            this.page = 1
            this.items = []
            this.FetchData(this.page,this.search,this.cleanValue,this.selectedtypes);
            this.awaitingSearch = false;
            console.log('fetching based on search timer')
          }, 1500); // 1 sec delay
        }
        this.awaitingSearch = true;
      },


          },
        mounted:function(){
          this.track()

          if(this.$route.path == '/watched'){
              this.watched = true;
          }
          this.FetchData(this.page,'','','');
          this.scroll();
          if(this.$route.query.a){
              this.$parent.showAlert(this.$route.query.a)
              }
        },
        beforeDestroy () {
          window.onscroll = undefined;
        },
        methods:{
            FetchData:function(page,search,areas,types){
            if(this.$store.getters.loggedIn) {
                var headers = { Authorization: `Bearer ${this.$store.state.accessToken}` }
            } else {
              var headers = {}
            }

            getAPI.get("/api/v1/sessions/?page="+page+'&q='+search + '&areas=' + areas + '&watched=' + this.watched + '&types=' + types  ,{headers: headers }).then(response => {
              console.log(response);
              this.authenticated = response.data.authenticated
              this.areas = response.data.areas
              this.types = response.data.session_types
              this.time_watched = response.data.time_watched
              this.count = response.data.count
              this.runningSearch = false;

              if(this.$route.query.area && !this.loaded){
                this.areas.forEach((item,index) =>{
                  if(item.name == this.$route.query.area && this.value.length == 0){
                      this.value.push(item)
                       }
                    }
                )
              } else {
                this.items = this.items.concat(response.data.items)
              }
             this.loaded = true;
          });

        },
        loadNext:function(){
            this.FetchData(this.page+1,this.search,this.cleanValue,this.selectedtypes)
            this.page = this.page + 1
        },
        	scroll () {
              window.onscroll = () => {
                  window.onscroll = ()=> {
                      if ((window.innerHeight + window.pageYOffset) >= document.body.offsetHeight && !this.allLoaded) {
                          this.loadNext()
                      }
                  };
              }
          },
        track () {
          this.$gtag.pageview({
          page_path: this.$route.fullPath,
          page_title:'gallery',
          })
        }
        },
        name: "Gallery.vue",
        components: {Item,Multiselect}
    }

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect__tag {
  background: var(--main-color)
  }
  .multiselect__option--highlight {
    background: var(--main-color)
  }

</style>

<style scoped>

    .font-weight-light {
        font-weight: 300 !important;
    }



</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue